module.exports = __webpack_public_path__ + "static/media/textProduct_Digital.ee719817.md";